import React from 'react';
import loading from '../assets/loading.mp4'
import  './loading.css'

const Preloader = ({ onFinish }) => {
    return ( <>
        <div className="preloader">

            <div className="loading-text">
                Loading<span className="dots"></span>
            </div>

            <video autoPlay muted playsInline onEnded={onFinish}>
                <source src={loading} type="video/mp4" />
            </video>

        </div>
    </> );
}
 
export default Preloader;